export const SEPHIRA_APP_URL = process.env.REACT_APP_SEPHIRA_APP_URL
export const SEPHIRA_ICONNECT_URL = 'https://localhost.iconnect.sephira.fr:9987'
